const m = window.require("@ember/utils");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;